import { useEffect, useRef, useState, useCallback } from 'react';
import { WS_URL } from '../config';
const RECONNECT_MS = 3000;

export default function useWebSocket(onMessage) {
  const [connected, setConnected] = useState(false);
  const wsRef     = useRef(null);
  const timerRef  = useRef(null);
  const onMsgRef  = useRef(onMessage);
  onMsgRef.current = onMessage;

  const connect = useCallback(() => {
    if (wsRef.current?.readyState === WebSocket.OPEN) return;
    const ws = new WebSocket(WS_URL);
    wsRef.current = ws;

    ws.onopen  = () => setConnected(true);
    ws.onclose = () => {
      setConnected(false);
      timerRef.current = setTimeout(connect, RECONNECT_MS);
    };
    ws.onerror = () => ws.close();
    ws.onmessage = (e) => {
      try { onMsgRef.current(JSON.parse(e.data)); }
      catch {}
    };
  }, []);

  const sendMessage = useCallback((msg) => {
    if (wsRef.current?.readyState === WebSocket.OPEN)
      wsRef.current.send(JSON.stringify(msg));
  }, []);

  useEffect(() => {
    connect();
    return () => {
      clearTimeout(timerRef.current);
      wsRef.current?.close();
    };
  }, [connect]);

  return { connected, sendMessage };
}
